import { Colors, Fonts, Metrics } from "Themes";

import Container from "react-bootstrap/Container";
import { IoMdAdd } from "react-icons/io";
import { mobileSize } from "./Metrics";
import styled from "styled-components";

export const CustomContainer = styled(Container)`
  width: 60%;
  @media ${mobileSize.large} {
    width: 100%;
  }
`;

export const MainContainer = styled.div`
  padding: 20px;
  margin: auto;
  width: 75%;
  margin-top: 2.5%;
  @media ${mobileSize.large} {
    margin: 1.25%;
    padding: 5px;
    width: 100%;
  }
`;

export const PageFailure = styled.div`
  border: solid 2px ${Colors.errorColor};
  border-radius: 10px;
  width: 40%;
  padding: 20px;
  margin: auto;
  color: ${Colors.errorColor};
  font-size: ${Fonts.fontSize.medium}px;
  @media ${mobileSize.large} {
    width: 90%;
  }
`;

export const MainBackground = styled.div`
  positon: absolute:
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
`;

export const MainHeaderTheme = styled.div`
  color: ${Colors.mainColor};
  border-bottom: solid 2px lightgray;
  text-align: left;
  padding-bottom: 10px;
  margin-bottom: 30px;
  font-size: 25px;
`;

export const TitleHeader = styled.div`
  font-size: ${Fonts.size.large}px;
  font-family: ${Fonts.primaryFontFamily};
`;

export const FormError = styled.div`
  color: red;
  font-size: 15px;
  text-align: left;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const FormSuccess = styled.div`
  color: green;
  font-size: 15px;
  text-align: left;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const ProjectUpdateContainer = styled.div`
  border: solid 2px lightgray;
  border-radius: 5px;
  padding: 10px;
  display: flex;
  max-width: 80%;
  justify-content: flex-start;
  min-width: 25%;
  cursor: pointer;
  &:hover {
    opacity: 0.75;
  }
`;

export const Card = styled.div`
  border: solid 2px lightgray;
  border-radius: 5px;
  padding: 10px;
  margin: 5px;
  flex: 1;
  background-color: white;
  overflow-x: auto;
`;

export const ProjectAvatarContainer = styled.div`
  border: solid 2px lightgray;
  height: 100px;
  width: 100px;
  border-radius: ${Metrics.borderRadius.medium};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  cursor: pointer;
  &:hover {
    opacity: 0.75;
  }
`;

export const ProjectImage = styled.img`
  height: 150px;
  width: 150px;
  border-radius: ${Metrics.borderRadius.small};
`;

export const ProjectImageContainer = styled.div`
  margin-right: 10px;
  border-radius: ${Metrics.borderRadius.medium};
  cursor: pointer;
  &:hover {
    opacity: 0.75;
  }
`;

export const ProjectNameContainer = styled.div`
  font-family: ${Fonts.primaryFontFamily};
  font-size: ${Fonts.size.medium}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  &:hover {
    opacity: 0.75;
  }
`;

export const ProjectDetailContainer = styled.div`
  font-size: ${Fonts.size.small}px;
`;

export const AddIconContainer = styled.div`
  border: solid 2px lightgray;
  border-radius: 100px;
  cursor: pointer;
  margin: 10px;
  padding: 10px;
  &:hover {
    background-color: lightgray;
  }
`;

export const FileUploadButton = styled.label`
  border: solid 2px lightgray;
  padding: 10px;
  border-radius: 5px;
  color: gray;
  text-align: center;
  cursor: pointer;
  font-family: ${Fonts.primaryFontFamily};
`;

export const AddIcon = styled(IoMdAdd)``;

export const StyledComponents = {
  FormError,
  ProjectUpdateContainer,
  TitleHeader,
};
